import axios from 'axios'
import { IResponse } from '../interfaces/common'
import { getConnectionString } from '../server/config/config'
import { AuthBackendServers } from '../server/config/AuthBackendServers'
import { IPostApi } from '../interfaces/IPostApi'
import { IGetApi } from '../interfaces/IGetApi'

export const apiGet = async <TParams, TResponse>({
  path,
  params,
  locale,
  headers,
}: IGetApi<TParams>): Promise<IResponse<TResponse>> => {
  const url = getConnectionString(AuthBackendServers, locale, path)

  const { data } = await axios.get<IResponse<TResponse>>(url, { params, headers, withCredentials: true })

  return data
}

export const apiPost = async <TBody, TResponse>({
  path,
  body,
  locale,
  headers,
}: IPostApi<TBody>): Promise<IResponse<TResponse>> => {
  const url = getConnectionString(AuthBackendServers, locale, path)

  const { data } = await axios.post<IResponse<TResponse>>(url, body, { headers, withCredentials: true })

  return data
}
